import { ArrowRight } from "lucide-react";
import { useContent } from "@/lib/content";
import { Media, SmartLink } from "./Media";
import { Reveal } from "./Reveal";

export const About = () => {
  const a = useContent().data.about;
  return (
    <section className="section" id="about" data-testid="about-section">
      <div className="wrap about">
        <Reveal>
          <Media src={a.image} w={800} sizes="(min-width: 850px) 50vw, 100vw" alt="Tranquil spa atmosphere" testId="about-media" />
        </Reveal>
        <Reveal delay={0.1}>
          <p className="eyebrow">{a.eyebrow}</p>
          <h2>{a.title}</h2>
          <p>{a.paragraph1}</p>
          <p>{a.paragraph2}</p>
          <a className="btn light" href="#visit" data-testid="about-find-spa-button">Find our spa <ArrowRight size={14} /></a>
          {a.media_link_label && <SmartLink to={a.media_link_url} className="btn gold about-cta" testId="about-media-link">{a.media_link_label} <ArrowRight size={14} /></SmartLink>}
        </Reveal>
      </div>
    </section>
  );
};
